import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'one-time-invest-terms',
        name: routeName.ONE_TIME_INVEST_TERMS,
        component: () => import('@/views/aplCatl640and631/A5/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '單筆增額投資金額申請說明', leaveAlert: true, code: 'A5', unableBack: true },
    },
    {
        path: 'one-time-invest',
        name: routeName.ONE_TIME_INVEST,
        component: () => import('@/views/aplCatl640and631/A5/apply/Index.vue'),
        meta: { auth: true, metaTitle: '單筆增額投資金額申請', leaveAlert: true, code: 'A5', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.ONE_TIME_INVEST_TERMS, routeName.CONFIRM_DATA, routeName.ONE_TIME_INVEST_SURVEY];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
    {
        path: 'one-time-invest-survey',
        name: routeName.ONE_TIME_INVEST_SURVEY,
        component: () => import('@/views/aplCatl640and631/A5/survey/Index.vue'),
        meta: { auth: true, metaTitle: '單筆增額投資金額申請', leaveAlert: true, code: 'A5', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.ONE_TIME_INVEST];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
